/**************************************************
 * Nombre:       Lista_Tipos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Tipo from "../../../Tarjetas/Tarjeta_Tipo";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../../Servicios/BD/obtenerCol";

const Lista_Tipos = () => {
    const [tipos, setTipos] = useState([]);

    useEffect(() => {
        obtenerCol('tipos').then(dox => {
            if (dox.res) {
                setTipos(dox.data);
            }
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={4}
        >

            {tipos.map((item) => (
                <Grid container size={{xs: 12, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Tipo item={item}/>
                </Grid>
            ))}

        </Grid>
    )

}
export default Lista_Tipos

